import { useEffect, useState } from 'react';

import { allFinished } from 'src/presentation/hooks/useResource';
import sidekickConfigurationResource, { SidekickConfig } from 'src/actions/sidekick/sidekickConfigurationResource';
import { useResourceValue } from 'src/presentation/hooks/useDocumentResource';

const useSidekickV1Conf = () => {
  const [customerId, setCustomerId] = useState<number | null>(null);

  const { value: sidekickConfiguration, loadingState } =
    useResourceValue<SidekickConfig>(sidekickConfigurationResource);

  useEffect(() => {
    if (!allFinished(loadingState)) return;

    const customerId = (sidekickConfiguration as SidekickConfig).v1CustomerId;

    setCustomerId(customerId);
  }, [sidekickConfiguration, loadingState]);

  return { customerId, isSidekickThreadsEnabled: !!customerId };
};

export default useSidekickV1Conf;
